import { render, staticRenderFns } from "./estados_domicilios.vue?vue&type=template&id=0023b794&"
import script from "./estados_domicilios.vue?vue&type=script&lang=js&"
export * from "./estados_domicilios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports